const initialState = {
    settings: {
        "prevent_password_reuse_count": 0,
        "password_expiry_days": 0,
        "enforce_password_rotation": false,
        "password_history": false,
        "min_password_length": 5,
        "require_special_characters": false,
        "require_numbers": false,
        "require_uppercase": false,
        "user_lockout": 0,
        "lockout_threshold": 0,
        "lockout_duration_minutes": 0,
        "require_password_reset_on_login": false,
        "is_2fa_enabled": false,
        "two_fa_method": [],
        "captcha_required": false,
        "captcha_type": "recaptcha",
        "user_limit": 0,
        "require_whitelisted_ips": false,
        "whitelisted_ips": [],
        "session_duration": 0,
        "is_user_throttling_enabled": false,
        "user_throttling_limit": 0,
        "user_throttling_period_unit": 0
    }
};

export const userSettingsReducer = (state = initialState, action) => {

    switch (action.type) {
        case 'CREATE_USERSETTINGS':
            return {
                ...state,
                settings: action.payload || initialState.settings
            };
        case 'TOGGLE_USERSETTING':
            return {
                ...state,
                settings: {
                    ...state.settings,
                    [action.payload]: !state.settings[action.payload]
                }
            };
        case 'UPDATE_USERSETTINGS':
            return {
                ...state,
                settings: {
                    ...state.settings,
                    [action.payload.key]: action.payload.value
                }
            };
        default:
            return state;
    }
};